import Vue from 'vue'
import Vuex from 'vuex'
import { getCartList } from '@/api/cart.js'
// import { getInfo } from '@/api/users.js'
import { post_community_edituserinfo } from '@/api/community.js'
// import { getAddresses_user } from '@/api/users.js'


let userInfo;
let login_token;
function	get_cookie(){
	let decodedCookies = {};
	let cookieValue = document.cookie;
	if(cookieValue && cookieValue.length != 0){
		cookieValue.split(';').forEach(cookie => {
			let parts = cookie.split('=');
			let key = decodeURIComponent(parts[0].trim()); //decodeURIComponent反转译
			let value = decodeURIComponent(parts[1]);
			decodedCookies[key] = value;
		});
		if(decodedCookies.user){
			userInfo = JSON.parse(decodedCookies.user);
			console.log(userInfo.user_id)
		}
		if(decodedCookies.token){
			login_token = decodedCookies.token;
		}
	}else{
		// this.LoginTips()
	}
}
get_cookie()
	
// let toekn = localStorage.getItem("toekn")
// console.log(toekn)
Vue.use(Vuex)
const state = {
	userinfo:{
		user_id: userInfo && userInfo.user_id ? userInfo.user_id : "", //用户id
		login_token:  login_token ? login_token : "", //用户login_token
		avatar: "", //头像
	 	nickname: "", //昵称
	 	thumb: '', //点赞数
	 	focus: '', //关注数
	 	followers: '', //粉丝数
	 	is_follow: '', //是否关注, 0否, 1是
	 	is_official: '', //是否官方账号, 0否, 1是
	},
	pageNameList:{},
	pageStates:{},
	fan_follower_status:{
		value: '',
		timestamp: Date.now(),
	},
	current_operation:'',
	// fan_follower_status:1,
	
	country_list:[],
	click_btn_name:'',
	order_id:'Hot',
	CLIENT_ID: process.env.CLIENT_ID,
	client_token:'',
	access_token:'',
	seoTitle: 'TOZO',
	seoDesc: 'TOZO',
	seoKeywords: 'TOZO',
	isPcDevice: false, // 判断当前设备是pc还是phone,
	webIsactive: true, // 个人中心列表展示使用
	dim_url: '',
	googleSignInParams: {
		client_id: '858532709023-75ql4dcu8rhqpbbmu1ceqd84lmu0353n.apps.googleusercontent.com'
	},
	fbSignInParams: {
		scope: 'email,user_likes,public_profile',
		return_scopes: true
	},
  // 导航栏
  navs: [],
  process: process.env.VUE_APP_IMG_URL,
  
  // userinfo: {
  //   id: null,
  //   shop_group_id: null,
  //   shop_id: null,
  //   gender_id: null,
  //   lang_id: null,
  //   risk_id: null,
  //   email: null,
  //   firstname: null,
  //   lastname: null,
  //   mobile_number: null,
  //   set_pwd_time: null,
  //   avatar: null,
  //   birthday: null,
  //   newsletter: null,
  //   registration_newsletter_ip: null,
  //   company: null,
  //   newsletter_add_time: null,
  //   optin: null,
  //   website: null,
  //   active: null,
  //   is_guest: null,
  //   delete_time: null,
  //   register_ip: null,
  //   updated_at: null,
  //   created_at: null,
  //   token: null,
  //   login_way: '' // 登录渠道: google、facebook、local
  // },
  have_list: '1',
  guestId: '',
  cart: {
    cartList: [
    ],
    total: 0,
    count: 0
  },
  bo_from: {
    name: ''
  },
  checkoutQuery: {},
  // 地址
  address: [],
  // lang: 1,
  // 货币列表
  currencies: [
    {
      currency_id: 2,
      full_name: 'US Dollar',
      id: 2,
      name: 'USD',
      symbol: '$'
    }
  ],
  // 当前选择货币
  currency: 2
}
const mutations = {
	setFanFollowerStatus(state, status) {
	   state.fan_follower_status = {
			value: status,
			timestamp: Date.now(),
		}; // 更新状态
	},
  setcountry_list(state, country_list) {
    state.country_list = country_list
  },
  setorder_id(state, order_id) {
    state.order_id = order_id
  },
  setclick_btn_name(state, click_btn_name) {
    state.click_btn_name = click_btn_name
  },
  setclient_token(state, client_token) {
    state.client_token = client_token
  },
  setaccess_token(state, access_token) {
    state.access_token = access_token
  },
  setSeo(state, seo) {
    state.seoTitle = seo.PS_META_TITLE
    state.seoDesc = seo.PS_META_DESCRIPTION
    state.seoKeywords = seo.PS_META_KEYWORDS
  },
  setGoogleLogin(state, value) {
    state.googleLogin = value
  },
  setFacebookLogin(state, value) {
    state.facebookLogin = value
  },
  checkoutQuery(state, value) {
    state.checkoutQuery = value
  },
  changeLogin_way(state, from) {
    state.login_way = from[1]
    const vm = from[0]
    const redirect = from[2]
    if (redirect === '/checkout') {
      vm.$router.replace(
        {
          path: vm.$route.query.redirect
        }
      )
    } else if (redirect === '/reset') {
      from[0].$router.replace('/index')
    } else if (redirect) {
      from[0].$router.replace(redirect)
    }
  },
  changeUserinfo(state, from) {
    state.userinfo = from
  },
  putinfo(state, value) {
    state.userinfo = Object.assign(state.userinfo, value)
  },
  signOut(state, from) {
    state.login_way = from[1]
    if (state.isPcDevice) {
      from[0].$message('Sign out success', 'success')
    } else {
      from[0].$notify({ message: 'Sign out success', type: 'success' })
    }
    state.userinfo = {}
  },
  cart(state, value) {
    state.cart = value
  },
  address(state, value) {
    state.address = value
  },
  language(state, value) {
    state.language = value
  },
  currencies(state, value) {
    state.currencies = value
  },
  currency(state, value) {
    state.currency = value
  },
  changehave_list(state, value) {
    state.have_list = value
  },
  webIsactive(state, value) {
    if (state.have_list === '2') {
      state.have_list = '3'
    } else {
      state.webIsactive = value
    }
  },
  navs(state, value) {
    state.navs = value
  },
  changeDeviceInfo(state, value) {
    state.isPcDevice = value
  },
  setGuestId(state, value) {
    state.guestId = value
  },
  yuan_from(state, value) {
    state.bo_from = value
  },
  setToken(state, value) {
    state.userinfo.token = value
  }
}
const actions = {
	updateFanFollowerStatus({ commit }, status) {
	   commit('setFanFollowerStatus', status); // 调用 mutation 更新状态
	},
  login(context, n) {
    context.commit('changeLogin_way', n)
  },
  li_from(context, n) {
    if (n.name !== 'BuyGoods') {
      context.commit('yuan_from', n)
    }
  },
  userinfo(context, n) {
	  console.log(n)
    context.commit('changeUserinfo', n[0].data)
    // 首次登录后，如果有游客ID,提交游客ID给后台合并购物车数据，合并后清空游客ID
    // 未最终决定。目前不清空游客ID
    const query = { customer_id: n[0].id }
    if (context.state.guestId) {
      query.id_guest = context.state.guestId
    }
    // getCartList(state.currency, query).then(res => {
    //   context.commit('cart', res.data)
    // })
  },
  getUserInfo({ state, commit }) {
    post_community_edituserinfo().then(res => {
		 console.log(res.data)
      commit('changeUserinfo', Object.assign({}, state.userinfo, res.data))
    }, (res) => {
		 console.log(res)
	 })
  },
  putinfo(context, n) {
    context.commit('putinfo', n)
  },
  signOut(context, n) {
    context.commit('signOut', n)
    context.commit('cart', { cartList: [], total: 0, count: 0 })
  },
  cart(context, n) {
    context.commit('cart', n)
  },
  address(context, n) {
    context.commit('address', n)
  },
  language(context, n) {
    context.commit('language', n)
  },
  currencies(context, n) {
    context.commit('currencies', n)
  },
  currency(context, n) {
    context.commit('currency', n)
  },
  navs(context, n) {
    context.commit('navs', n)
  },
  setGuestIdAsync(context, value) {
    context.commit('setGuestId', value)
  }
}
const getters = {
   getFanFollowerStatus: (state) => state.fan_follower_status, // 获取状态值
}

export function createStore() {
  const store = new Vuex.Store({
    state, mutations, actions, getters
  })
  return store
}
